import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { Environment } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { popHistory, resetContactUsFocus, updateUITabViewInfo } from '../../app/appActions';
import {
  shouldResetFocusSelector,
  isAgaveSelector,
  isAmcSelector,
  isGetHelpSelector,
  isNonAgaveSelector,
  isTeamsSelector,
  isThirdPartySelector,
  showAppBar,
  sourceAppSelector,
  isSmbHubSelector,
  showWindowsUpdateAvailableForSASelfHelp,
  showWindowsUpdateAvailableForSAModalities,
  showEndOfLifeMessageForSASelfHelp,
  showEndOfLifeMessageForSAModalities,
  showWin10EndOfSupportMessage
} from '../../app/selectors/contactUsSelector';
import { ContactUsApp } from '../presentationalComponents/contactUsApp';
import { dispatchBypassThemeRouting, dispatchGetAlchemyThemeRoutingData, dispatchGetRegionInfo, dispatchShowCoachmark, dispatchUserInfoFetch } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { regionInfoSelector, useAnnouncementFloatSelector } from '../reduxUpdater/selectors/sharedStateSelectors';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    inArticle: state.NavState.inContactArticle,
    articleUrl: state.NavState.contactIframeSrc,
    backButtonDisabled: (state.NavState.backButtonDisabled && !state.NavState.inContactArticle),
    runningInSoc: state.GlobalState.environment === Environment.SOC,
    globalState: state.GlobalState,
    hideSelfHelpSmcIvr: state.ContactState.SharedState.hideSelfHelpSmcIvr,
    isOutlookDotCom: state.ContactState.SharedState.isOutlookDotCom,
    uITabViewStack: state.NavState.uITabViewStack,
    showModalitiesStickyFooter: state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
    appName: state.GlobalState.sourceApp || state.GlobalState.appVer,
    sourceApp: sourceAppSelector(state),
    isThirdParty: isThirdPartySelector(state),
    isAgave: isAgaveSelector(state),
    isNonAgave: isNonAgaveSelector(state),
    isTeams: isTeamsSelector(state),
    regionInfo: regionInfoSelector(state),
    isAmc: isAmcSelector(state),
    isGetHelp: isGetHelpSelector(state),
    showAppBar: showAppBar(state),
    showWindowsUpdateAvailableForSASelfHelp: showWindowsUpdateAvailableForSASelfHelp(state),
    showWindowsUpdateAvailableForSAModalities: showWindowsUpdateAvailableForSAModalities(state),
    showEndOfLifeMessageForSASelfHelp: showEndOfLifeMessageForSASelfHelp(state),
    showEndOfLifeMessageForSAModalities: showEndOfLifeMessageForSAModalities(state),
    showWin10EndOfSupportMessage: showWin10EndOfSupportMessage(state),
    useAnnouncementFloat: useAnnouncementFloatSelector(state),
    shouldResetFocus: shouldResetFocusSelector(state),
    isSmbHub: isSmbHubSelector(state),
  };
};

const mapDispatchToProps = {
  popHistory,
  dispatchUserInfoFetch,
  dispatchGetRegionInfo,
  dispatchShowCoachmark,
  dispatchGetAlchemyThemeRoutingData,
  dispatchBypassThemeRouting,
  resetContactUsFocus,
  updateUITabViewInfo
};

export const ContactUsAppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ContactUsApp, getContactUsStyles));
